export const PATH_SECTION = {
  "/app": "dashboard",
  "/app/cassa": "cassa",
  "/app/prenotazioni": "prenotazioni",
  "/app/production": "production",
  "/app/partners": "partners",
  "/app/suppliers": "partners",
  "/app/orders": "orders",
  "/app/orders?dept=all": "orders",
  "/app/caldane": "orders",
  "/app/ricorrenti": "orders",
  "/app/torte": "orders",
  "/app/panettoni": "orders",
  "/app/avanzi": "orders",
  "/app/preventivi": "orders",
  "/app/b2b": "orders",
  "/app/foodcost": "foodcost",
  "/app/acquistati": "purchased",
  "/app/eventi": "special",
  "/app/messages": "partners",
  "/app/recipes": "recipes",
  "/app/formula": "formula",
  "/app/lab": "lab",
  "/app/inventory": "inventory",
  "/app/inventario": "inventory",
  "/app/devai": "devai",
  "/app/ingredients-list": "inglist",
  "/app/catalog": "catalog",
  "/app/listino": "listino",
  "/app/reorder": "reorder",
  "/app/shifts": "shifts",
  "/app/azienda": "azienda",
  "/app/attendance": "attendance",
  "/app/invoices": "invoices",
  "/app/staff": "staff",
  "/app/waste": "waste",
  "/app/documents": "documents",
  "/app/past-docs": "documents",
  "/app/storico-produzione": "inventory",
  "/app/labels-history": "inventory",
  "/app/foto": "gallery",
  "/app/payments": "payments",
  "/app/stats": "stats",
  "/app/reports": "reports",
  "/app/billing": "billing",
  "/app/guide": "guide",
  "/app/trash": "trash",
};

export const ROLE_HOME = { dipendente: "/app/production", sala: "/app/production", lab: "/app/production", operator: "/app/production", impastatore: "/app/production", preparatore: "/app/production", ordini: "/app/production", pasticcere: "/app/production" };
